import { BiLingualValue } from 'types/common'

export const BOLT_X_PLENTY_FROM = 'bolt-x-plenty'

export const TESTIMONIALS: {
  id: number
  quote: BiLingualValue<string>
  author: string
  location: BiLingualValue<string>
  avatar?: string
}[] = [
  {
    id: 1,
    quote: {
      fr: 'La transition énergétique a toujours été un concept vague pour moi. En investissant dans Plenty, je comprends désormais comment cela fonctionne réellement, et comment nous, en tant que citoyens, pouvons y contribuer concrètement.',
      nl: 'De energietransitie was voor mij altijd een vaag begrip. Door in Plenty te investeren, zie ik nu hoe het écht werkt, en hoe wij als burgers daar zelf een steentje aan kunnen bijdragen.'
    },
    author: 'Kevin',
    location: {
      fr: 'Gand',
      nl: 'Gent'
    },
    avatar: 'plenty/testimonials/kevin-square'
  },
  {
    id: 2,
    quote: {
      fr: 'Ce qui rend Plenty unique, selon moi, c’est son esprit jeune. C’est donc une évidence pour moi de me rallier à une mission portée par un groupe aussi dynamique.',
      nl: 'Wat Plenty uniek maakt is volgens mij de jonge geest. Het is dan ook een no-brainer om me met zo’n leuke groep mensen achter de missie te scharen.'
    },
    author: 'Sylke',
    location: {
      fr: 'Anvers',
      nl: 'Antwerpen'
    },
    avatar: 'plenty/testimonials/sylke-square'
  },
  {
    id: 3,
    quote: {
      fr: 'Plenty a été mon tout premier investissement. J’ai été immédiatement convaincue, car cela rapporte plus que mon compte épargne.',
      nl: 'Plenty was mijn allereerste investering. Ik was meteen overtuigd, aangezien het meer opbrengt dan mijn spaarrekening.'
    },
    author: 'Magda',
    location: {
      fr: 'Laakdal',
      nl: 'Laakdal'
    },
    avatar: 'plenty/testimonials/magda-square'
  },
  {
    id: 4,
    quote: {
      fr: 'Ce qui m’a convaincu, c’est que Plenty est une coopérative avec une mission. On n’investit pas seulement de l’argent, mais aussi dans une transition écologique. Le fait que ce soit une idée de Bolt rend le projet encore plus fort.',
      nl: 'Wat mij overtuigde, is dat Plenty een coöperatie is met een missie. Je investeert niet enkel financieel, maar in een ecologische transitie. Dat het een idee van Bolt is, maakt het alleen maar sterker.'
    },
    author: 'Bastien',
    location: {
      fr: 'Bruxelles',
      nl: 'Brussel'
    },
    avatar: 'plenty/testimonials/bastien-square'
  }
]
